import { QueryObserverResult, useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { HISTORY_QUERY_KEY } from '../api/apiConsts';
import { getRelevosHistory } from '../api/relevos';
import { Paginated } from '../common/models/paginated';
import { HistoryQueryRequest } from '../modules/History/model/HistoryQueryRequest';
import { RelevosHistoryModel } from '../modules/History/model/RelevosHistoryModel';

const getRelevosHistoryQueryKey = (page: number, limit: number, historyQueryParams: HistoryQueryRequest) => [
  HISTORY_QUERY_KEY,
  { page, limit, ...historyQueryParams },
];

export const useRelevosHistory = (
  historyQueryParams: HistoryQueryRequest,
  page: number,
  limit: number,
): QueryObserverResult<Paginated<RelevosHistoryModel>, AxiosError> => {
  return useQuery(
    getRelevosHistoryQueryKey(page, limit, historyQueryParams),
    () => getRelevosHistory(historyQueryParams, page, limit),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
      enabled: !!historyQueryParams.restaurantIds.length && !!historyQueryParams.endDate,
    },
  );
};
